<template>
  <v-btn
    class="bxp-btn"
    :class="getClasses()"
    :color="getColor()"
    depressed
    rounded
    :outlined="isLinear()"
    :disabled="disabled"
    v-on="$listeners"
    :href="href"
    :loading="loading"
  >
    <template v-slot:default v-if="!loading">
      <slot></slot>
    </template>
  </v-btn>
</template>

<script>
export default {
  props: ["linear", "color", "disabled", "href", "loading"],
  methods: {
    isLinear() {
      return this.linear !== undefined;
    },
    getColor() {
      return this.color === undefined ? "primary" : this.color;
    },
    getClasses() {
      return this.isLinear() ? "bxp-linear-btn " : "";
    },
  },
};
</script>

<style>
.bxp-btn.v-btn {
  /* padding: 0 32px !important;
    height: 52px !important;
    font-size: 16px !important;
    letter-spacing: 0 !important;
    text-transform: none !important;
    margin-bottom: 16px;
    border-radius: 100px !important; */
  box-sizing: border-box;
  height: 38px;
  width: 140px;
  border: 2px solid #d4e7a1;
  opacity: 0.8;
  border-radius: 21px;
  background-color: #ffffff;
}
.bxp-btn.v-btn:hover,
.bxp-btn.v-btn:active {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}
.bxp-btn.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  color: white !important;
  background-color: var(--v-primary-base) !important;
  opacity: 0.45;
}

/* Linear */
.bxp-btn.bxp-linear-btn {
  border-width: 2px !important;
}
.bxp-btn.bxp-linear-btn.primary--text,
.bxp-btn.bxp-linear-btn.secondary--text {
  color: rgba(0, 0, 0, 0.87) !important;
}
.bxp-btn.bxp-linear-btn.primary--text {
  border-color: var(--v-primary-base) !important;
}
.bxp-btn.bxp-linear-btn.secondary--text {
  border-color: var(--v-secondary-base) !important;
}

.bxp-btn.bxp-linear-btn.primary--text:before {
  background-color: var(--v-primary-base) !important;
}
.bxp-btn.bxp-linear-btn.secondary--text:before {
  background-color: var(--v-secondary-base) !important;
}

.bxp-btn.bxp-linear-btn.primary--text .v-ripple__animation {
  color: var(--v-primary-base) !important;
}
.bxp-btn.bxp-linear-btn.secondary--text .v-ripple__animation {
  color: var(--v-secondary-base) !important;
}
</style>
